var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEryxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297.5 134.3",
    style: {
      enableBackground: "new 0 0 297.5 134.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.3,14.7c-11.9,0-21.1,3.9-27.8,11.6C6,33.8,2.8,44.2,2.8,57.5c0,14,3.3,24.7,10,32.2 c6.7,7.7,15.9,11.6,27.8,11.6c9.8,0,17.9-2.4,24.4-7.2c6.5-4.6,10.8-11.2,13.1-20H62.5c-2.5,0-4.5,0.5-5.8,1.6 c-1,0.9-1.6,1.6-2.3,2.5c-0.5,0.7-2.1,2.1-3.4,2.8c-2.5,1.4-5.5,2.2-9.1,2.2c-5.4,0-9.5-1.7-12.2-5c-2.9-3.1-4.5-7.9-4.7-14.4h54 c0.2-0.4,0.3-1.1,0.3-2.2v-3.4c0-13.7-3.3-24.5-10-32.2C62.5,18.4,52.8,14.7,40.3,14.7z M25,49.6c0.2-5.4,1.8-9.6,4.7-12.5 c2.9-2.9,6.7-4.4,11.2-4.4c5,0,8.8,1.5,11.6,4.4c2.5,2.7,4,6.9,4.4,12.5H25z M113.3,18.7c-5.3,1.5-9.9,3.7-13.9,6.9 c-4.2,3.3-7.4,7.8-9.8,13.3C87.2,44.4,86,51.2,86,59.4v40.3h21.9V56.8c0-6.3,1.5-10.8,4.4-13.7c2.9-2.9,7.1-4.2,13-4.4l7.3-22.2 c0,0-2.4,0-2.9,0C124.1,16.5,118.7,17.3,113.3,18.7z M197,16.5c-5.4,0-8.7,2.5-10,7.5l-14.7,51.2l-16.9-58.7h-22.8l27.7,83.2 c1.6,3.9,1.1,7.1-1.3,9.1c-2.4,2-5.7,3-9.8,3h-5.9v17.4c0.6,0.1,3.3,0.3,4.7,0.4c0.6,0,1.3,0,2.2,0h2.2c8.5,0,14.7-1.2,18.4-3.7 c3.7-2.9,6.9-7.8,9.4-14.7l31.9-94.7H197z M263.2,57.1l26.3-40.5h-18.2c-4.4,0-7.3,2-9.4,5.6l-11.5,19.3l-14.4-25h-24.1l25.6,40.3 l-27.2,42.8h25.3l15.3-26.2l14.7,26.2h25L263.2,57.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEryxLogo);
export default __webpack_public_path__ + "static/media/eryx-logo.60e5faf862e20ad15382d416aff7b88a.svg";
export { ForwardRef as ReactComponent };